import { createAction } from 'redux-actions'

export const initApp = createAction('[app] init app')
